import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, inject } from '@angular/core';

import { EpcotConfig, ImagesConfig } from '@frontend/sports/common/client-config-data-access';
import { VirtualCompetitionImageType } from '@frontend/sports/common/core/data-access/sport-model';
import { ImageRootPath } from '@frontend/sports/participant-image/feature';
import { UtilsService } from '@frontend/vanilla/core';

@Component({
    selector: 'ms-tournament-groups-participants',
    templateUrl: './tournament-groups-participants.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgOptimizedImage],
})
export class TournamentGroupsParticipantsComponent implements OnInit {
    private imagesConfig = inject(ImagesConfig);
    private utilsService = inject(UtilsService);
    private changeRef = inject(ChangeDetectorRef);
    private epcotConfig = inject(EpcotConfig);

    private static FALLBACK_IMAGE = 'fallback';
    private static FALLBACK_FLAGS_IMAGE = 'fallback_flag';
    private static FALLBACK_IMAGE_EPCOT = 'epcot_fallback';

    @Input() participantId: string;
    @Input() sportId: number;
    @Input() imageType: VirtualCompetitionImageType;

    placeholder: string;
    image: string;
    error = false;

    ngOnInit(): void {
        const participantTemplateUrl = this.imagesConfig.participantImageUrl;

        let fallbackImage = this.epcotConfig.isEnabled
            ? TournamentGroupsParticipantsComponent.FALLBACK_IMAGE_EPCOT
            : TournamentGroupsParticipantsComponent.FALLBACK_IMAGE;
        // when we have default imageType show home jursey
        let participantId = this.participantId + '_1';

        if (this.imageType === VirtualCompetitionImageType.Flags) {
            fallbackImage = this.epcotConfig.isEnabled
                ? TournamentGroupsParticipantsComponent.FALLBACK_IMAGE_EPCOT
                : TournamentGroupsParticipantsComponent.FALLBACK_FLAGS_IMAGE;
            participantId = this.participantId;
        }

        this.image = this.utilsService.format(participantTemplateUrl, ImageRootPath.Live, this.sportId, participantId);
        this.placeholder = this.utilsService.format(participantTemplateUrl, ImageRootPath.Live, this.sportId, fallbackImage);
    }

    loadingError() {
        this.error = true;
        this.changeRef.markForCheck();
    }
}
